import { render, staticRenderFns } from "./BaseMitHeader.vue?vue&type=template&id=5168a388&scoped=true"
import script from "./BaseMitHeader.vue?vue&type=script&lang=js"
export * from "./BaseMitHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5168a388",
  null
  
)

export default component.exports